<nav class="sb-topnav navbar navbar-expand justify-content-between">
    <!-- Navbar Brand-->
    <a class="navbar-brand" href="#" *ngIf="isMobileLayout">
        <img src="assets/img/logo.png" alt=""> </a>

    <!-- Sidebar Toggle-->
    <button class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 sidebarToggle mobile"
        (click)="toggleBlockedClass()"><i class="fa-solid fa-bars"></i></button>
    <!-- Coupon Banner -->
    <div class="coupon-banner d-flex align-items-center px-3 py-2 rounded mobile-hide justify-content-around"
        *ngIf="!isMobileLayout">
        <div class="couponicon  me-3">
            <img src="assets/img/coupon_icon.png" alt="">
        </div>
        <div class="coupontext  me-4">
            <h6> Congratulations! <i> Unlock GOA 2D/1N HOLIDAY COUPON</i> </h6>
            <p>Just activate your coupon now to unlock this offer.</p>
        </div>
        <div class="couponbtn">
            <button class="btn btn-warning btn-sm">Activate coupon</button>
        </div>
    </div>

    <!-- Navbar-->
    <ul class="navbar-nav ml-auto ms-md-0 me-3 me-lg-4 align-items-center profile_con" style="padding-left:0px">
        <li *ngIf="!isSearchPropertiesRoute">
            <button class="btn btn-default"><span style="color: green;"><b>Free Trial</b></span> </button>
        </li>
        <li>
            <a class="text-dark" (click)="calander()"><i class="fa-solid fa-calendar"></i></a>
        </li>
        <li>
            <a class="me-3 text-dark"><i class="fa-solid fa-bell"></i></a>
        </li>

        <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <img src="{{lookupModel.getLoggedUser().personalDetails.profilePic || 'assets/img/profile_3.png'}}"
                    alt="profile" width="30px"><span> {{lookupModel.getLoggedUser().personalDetails.firstName}} </span>
                <i class="fa-solid fa-chevron-down"></i>
            </a>
            <!-- <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li><hr class="dropdown-divider" /></li>
                <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
            </ul> -->
            <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" [ngClass]="{'show':visibleDropdown}"
                aria-labelledby="userDropdown">
                <a class="dropdown-item" (click)="profile()">
                    <i class="ri-user-line"></i>
                    My Profile
                </a>
                <a class="dropdown-item" (click)="favoriteListing()">
                    <i class="ri-heart-3-line"></i>
                    Favorites
                </a>
                <!-- <a class="dropdown-item" (click)="favoriteProjects()">
                  <i class="ri-heart-3-line"></i> 
                  Favorite Projects
                    
                </a>
                <a class="dropdown-item" (click)="favoritePgHostel()">
                  <i class="ri-heart-3-line"></i> 
                  Favorite Pg/Hostels
                </a> -->
                <!-- <a class="dropdown-item" (click)="getLeadsForProperties()">
                  <img src="assets/img/leadicon.png" style="width: 20px; height: auto;">
                  Leads
                </a> -->
                <!-- <a class="dropdown-item" (click)="getLeadsForProjects()">
                  <img src="assets/img/leadicon.png" style="width: 20px; height: auto;">
                  Project Leads
                </a>
                <a class="dropdown-item" (click)="getLeadsForPgHostels()">
                  <img src="assets/img/leadicon.png" style="width: 20px; height: auto;">
                  Pg/Hostels Leads
                </a> -->
                <!-- <a class="dropdown-item" (click)="myfavorites()">
                    <i class="ri-settings-2-line"></i>
                    My Favorites
                </a> -->
                <a class="dropdown-item" (click)="changepwd()">
                    <img src="assets/img/changepwdicon.png" style="width: 20px; height: auto;">
                    Change Password
                </a>
                <!-- <div class="dropdown-divider"></div> -->
                <a class="dropdown-item" (click)="logout()">
                    <i class="ri-logout-box-line"></i>
                    Logout
                </a>
            </div>
        </li>
    </ul>
    <ng-container *ngIf="isMobileLayout">
        <div id="layoutSidenav">
            <div id="layoutSidenav_nav">
                <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                    <!-- <div class="d-flex justify-content-end p-2">
                        <button class="btn btn-sm btn-outline-light">
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                    </div> -->
                    <div class="sb-sidenav-menu m-2">
                        <div class="nav">
                            <a class="nav-link" (click)="routeRedirect('/dashboard')">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-house"></i></div>
                                Home
                            </a>
                            <a class="nav-link" (click)="routeRedirect('/search/searchProp')">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-magnifying-glass-location"></i>
                                </div>
                                Search Property

                            </a>
                            <a class="nav-link" (click)="routeRedirect('Post-Property/propertyModules')">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-chart-bar"></i></div>
                                List Property
                            </a>
                            <a class="nav-link" (click)="routeRedirect('/My-Properties')">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-chart-bar"></i></div>
                                My Properties
                            </a>
                            <a class="nav-link" (click)="routeRedirect('/myStaff')"
                                *ngIf="rsbLookup.getLoggedUser().type === 'franchise' || rsbLookup.getLoggedUser().type === 'subfranchise'">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-users"></i></div>
                                My Staff
                            </a>
                            <a class="nav-link" (click)="routeRedirect('/My-Subfranchise')"
                                *ngIf="rsbLookup.getLoggedUser().type === 'franchise'">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-laptop"></i></div>
                                Sub Franchises
                            </a>
                            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#crm"
                                aria-expanded="false" aria-controls="collapseLayouts">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-users-gear"></i></div>
                                CRM & Leads
                                <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                            </a>
                            <div class="collapse" id="crm" aria-labelledby="headingOne"
                                data-bs-parent="#sidenavAccordion">
                                <nav class="sb-sidenav-menu-nested nav">
                                    <a class="nav-link" (click)="routeRedirect('/Leads')">Leads</a>
                                    <a class="nav-link" (click)="routeRedirect('/organizedLeads')">Oppurtunities</a>
                                    <a class="nav-link" (click)="routeRedirect('/FollowUp')">Follow up</a>
                                </nav>
                            </div>
                            <!-- <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#nexusaddon"
                            aria-expanded="false" aria-controls="collapseLayouts">
                            <div class="sb-nav-link-icon"><i class="fa-solid fa-money-bill"></i></div>
                            Nexus <span class="text-danger ms-1"> Adon</span>
                            <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                        </a>
                        <div class="collapse" id="nexusaddon" aria-labelledby="headingOne"
                            data-bs-parent="#sidenavAccordion">
                            <nav class="sb-sidenav-menu-nested nav">
                                <a class="nav-link" href="#">Nexus</a>
                                <a class="nav-link" href="#">Nexus</a>
                            </nav>
                        </div> -->
                            <a class="nav-link" (click)="routeRedirect('/sales')">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-chart-column"></i></div>
                                Sales
                            </a>

                            <a class="nav-link" (click)="routeRedirect('/billing')"
                                *ngIf="rsbLookup.getLoggedUser().type === 'franchise' || rsbLookup.getLoggedUser().type === 'subfranchise'">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-chart-column"></i></div>
                                Billing
                            </a>
                            <a class="nav-link" href="#" (click)="routeRedirect('/Support&Help')">
                                <div class="sb-nav-link-icon"><i class="fa-solid fa-headset"></i></div>
                                Support
                            </a>
                        </div>
                        <button class="btn btn-desktop btn-sm sidebarToggle" href="#!"><i
                                class="fa-solid fa-chevron-left"></i></button>
                    </div>
                    <!-- <div class="position-fixed bottom-0 start-0 m-3 mb-3">
                    <div class="card refer_widget">
                        <div class="card-body">
                            <img src="assets/img/gift_icon.png" alt="">
                            <span>Refer and <span class="text-primary"> earn</span> </span>
                            <button class="btn btn-light">Invite friends</button>
                        </div>
                    </div>
                </div> -->
                </nav>
            </div>

        </div>
    </ng-container>
</nav>